// Universal helper to extract a human-readable message from any API/JS error.
// Handles FastAPI/Pydantic validation errors (array of objects) safely,
// so that React never receives an object as a child.

export function errorMessage(err, fallback = "Si è verificato un errore. Riprova.") {
    if (!err) return fallback;

    // Direct string
    if (typeof err === "string") return err;

    // Axios-style response
    const detail = err?.response?.data?.detail ?? err?.data?.detail ?? err?.detail;

    // Pydantic returns an array of {type, loc, msg, input, ctx, url}
    if (Array.isArray(detail)) {
        const msgs = detail
            .map((d) => {
                if (typeof d === "string") return d;
                if (d && typeof d === "object" && typeof d.msg === "string") return d.msg;
                return null;
            })
            .filter(Boolean);
        if (msgs.length) return msgs.join(" · ");
    }

    // Single string detail
    if (typeof detail === "string") return detail;

    // Single object with msg field
    if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;

    // Fallback to standard Error.message
    if (typeof err?.message === "string") return err.message;

    return fallback;
}
